import Container from 'react-bootstrap/Container';
import { Alert, Button, Card, Table, Modal, Accordion, Form, Tooltip} from 'react-bootstrap';
import {Sida,Rubrik,ContentWrapper,Stycke,StyckeCompact} from "../ContentStyles";
import useBackend, {Loading, CallAPI, CallAPIGet,Check, CallDownload} from '../../services/useBackend';
import {MaterialReactTable, showRowExpandColumn} from 'material-react-table';
import React, { useState ,useEffect, useReducer, fetchData,useMemo} from 'react';
import {DateTimeToLocal, MultiselectGetOptions, MultiselectGetDefaultValues, SplitoutLocalDateFromISO, getOptions, metaLookUpTitle, getPeriodOptions} from '../../services/misc';
import EditVerification from './editVerificationComponent';
import NewCompany from './newCompanyComponent';
import NewPeriod from './newPeriodComponent';
import { FaFilePdf, FaReceipt, FaEnvelope,FaBars, FaUser, FaFileDownload, FaDownload } from 'react-icons/fa';

import download from 'downloadjs'

function Verifications() {  
  const [editVerificationModalshow, setEditVerificationModalshow] = useState(false);
  const [selectedVerificationData,  setSelectedVerificationData]  = useState({ Verification: {Identity:"", Description:"",  VerificationFiles: [],  BookKeepingTransactions: [], BookKeepingDocuments: [] }});  

  const {loading:loadingmeta, data:metadata, Refresh:metaRefresh} = useBackend(process.env.PUBLIC_URL+'/api/meta');    
  const {loading, data, Refresh, Seek} =  useBackend('/api/v1/bookkeeping/verifications');

  const editVerificationHandler = async (event, rowData)  =>  {
    let {resultVariant, resultVisible, resultText, errorsException, jsondata} = await CallAPIGet('/api/v1/bookkeeping/verifications/' + rowData.original.Guid);
	  setSelectedVerificationData(jsondata)
	  setEditVerificationModalshow(!editVerificationModalshow);
  }

  const newVerificationHandler = async (event, rowData)  =>  {    
	  setSelectedVerificationData({Verification:{ Identity:"Nytt verifikat", Guid:"00000000-0000-0000-0000-000000000000", Document:"", BookKeepingTransactions:[] }});
	  setEditVerificationModalshow(!editVerificationModalshow);
  }

  const downloadSIE = async (event)  =>  {    
    console.log("DownloadSIE");
    // metadata.User.SelectedBookKeepingPeriodGuid
    const csv = await CallDownload("/api/v1/bookkeeping/export/"+metadata.User.SelectedBookKeepingPeriodGuid);
    download(csv, metadata.User.SelectedBookKeepingPeriodGuid+".SE", 'text/csv')
  }

  const setActiveCompany = async ()  =>  {
  }

  const setActivePeriod = async (SelectedBookKeepingPeriodGuid)  =>  {
		const formDataObj = {};
    formDataObj.SelectedBookKeepingPeriodGuid = SelectedBookKeepingPeriodGuid;
    let {resultVariant, resultVisible, resultText, errorsException, jsondata} = await CallAPI('/api/v1/bookkeeping/setactiveperiod/',"PATCH",JSON.stringify(formDataObj));
    setPagination({ pageIndex: 0, pageSize: 25 });
    Refresh();
    metaRefresh();
  }

  const columns = useMemo(() => [    
      { size: 40, accessorKey: 'Identity', header: 'Identity', enableColumnActions: false },
      { size: 40, accessorKey: 'Description', header: 'Description', enableColumnActions: false },

      { size: 20, accessorKey:'Date', header: 'Datum' , enableColumnActions: false,
        Cell: ({ cell }) => SplitoutLocalDateFromISO(cell.getValue()),        
      },

      { size: 40, accessorKey: 'DocumentsCnt', header: 'Documents', enableColumnActions: true },

      { size: 20, accessorKey:'AutoBalanced', header: 'AutoBalanced', enableOrdering: true, enableColumnOrdering: true, enablePinning: true, enableColumnActions: true,
            Cell: ({ cell }) => ( <Check checked={cell.getValue()}/> ),
      },

      { size: 20, accessorKey:'InBalance', header: 'InBalance', enableOrdering: true, enableColumnOrdering: true, enablePinning: true, enableColumnActions: true,
        Cell: ({ cell }) => ( <Check checked={cell.getValue()}/> ),
      }      
    ]
  );

  const [pagination, setPagination] = useState({ pageIndex: 0, pageSize: 25 });

  const initialState = { density: 'compact', columnVisibility: { } };      

  const state = { pagination };     

  if (!loading&&!loadingmeta) {
    return (
      <ContentWrapper>
        <EditVerification VerificationData={selectedVerificationData} MetaData={metadata} show={editVerificationModalshow} fn={()=> {setEditVerificationModalshow(!editVerificationModalshow); Refresh();} } refresh={()=> { Refresh();} } setSelectedVerificationData={setSelectedVerificationData} />  
        <Sida>
          { (metadata.BookKeepingCompanys.length > 0 && metadata.BookKeepingPeriods.length > 0) ?
            <MaterialReactTable columns={columns} data={data.Period.Verifications} state={state} initialState={initialState}  onPaginationChange={setPagination} manualPagination= {false}  autoResetPageIndex= {false}
              muiTablePaginationProps={{ showFirstButton: false, showLastButton: false, showRowExpandColumn: true, rowsPerPageOptions: [25, 50, 75, 100], labelRowsPerPage:"Rader" }}            
              
              renderTopToolbarCustomActions= {() => (
                <div style={{width:"100%"}}>
                  <div style={{float:"left"}}>
                    <span>Verifikationer</span>
                  </div>

                  <div style={{float:"right", display: "flex"}}>    

                      <Button style={{float: "left", whiteSpace:"nowrap"}} onClick={()=>newVerificationHandler()}>Nytt Verifikat</Button>&nbsp;
                      <Button style={{float: "left", whiteSpace:"nowrap"}} onClick={()=>downloadSIE()} title='Ladda ner SIE-fil'>SIE</Button> &nbsp;

                      <Form.Select onChange={ async (e) => {setActiveCompany(e.target.value);}} defaultValue={metadata.User.SelectedBookKeepingCompanyGuid}   >
                        {!loading && getOptions(metadata.BookKeepingCompanys)}
                      </Form.Select>&nbsp;

                      <Form.Select onChange={ async (e) => {setActivePeriod(e.target.value); }} defaultValue={metadata.User.SelectedBookKeepingPeriodGuid} >
                        {!loading && getPeriodOptions(metadata.BookKeepingPeriods)}
                      </Form.Select>
                  </div>                             
                </div>
              )}
              
              muiTablePaperProps={{elevation: 0, sx: {borderRadius: '0',border: '0px dashed #e0e0e0'} }} 
              muiTableBodyRowProps={({ row }) => ({
              onClick: (event) => {editVerificationHandler(event, row);},sx: {cursor: 'pointer'},})}
            />
          :
          <>
            {metadata.BookKeepingCompanys.length == 0 && <><NewCompany RefreshFn={()=> {metaRefresh();}}></NewCompany></> }<br></br>
            {metadata.BookKeepingCompanys.length > 0 && metadata.BookKeepingPeriods.length == 0  && <><NewPeriod RefreshFn={()=> {metaRefresh();}}></NewPeriod></> }
          </> }
        </Sida>

      </ContentWrapper>        
    );
  } else {
    return (<Loading />);        
  }    
}

export default Verifications;